<div class="container">
    {{text}}
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>